<script lang="ts">
    import type { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import type { RewardsPointsRewardEntity } from "@apps/rewards/entities/entities";
    import type RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";

    import RewardsPoints from "../RewardsPoints.svelte";

    //Props
    export let reward: RewardsPointsRewardEntity;
    export let i18n: GwI18n;
    export let amountFormatter: RewardsAmountFormatter;
    export let pointsNamespace: RewardsTranslationNamespaces;
</script>

<RewardsPoints
    points={reward.points}
    {amountFormatter}
    {i18n}
    {pointsNamespace}
/>
